import {cn} from '@utils';
import {useUsabilityVariant} from '../HaNMaps/useUsabilityVariant';

export const VariantSelector = () => {
  const {activeVariant, setActiveVariant} = useUsabilityVariant();

  return (
    <div className="absolute top-20 right-10 bg-white rounded shadow p-3">
      <div className="flex flex-col items-center">
        <div className="text-sm text-gray-600">Select variant</div>

        <div className="flex space-x-2 mt-2">
          {(['A', 'B'] as const).map((variant) => (
            <button
              key={variant}
              onClick={() => setActiveVariant(variant)}
              className={cn('flex items-center justify-center bg-white text-black size-10 rounded border', {
                'bg-blue-500 text-white font-bold': activeVariant === variant,
              })}>
              {variant}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
